import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS } from "@/types";
import { toastApiError } from "@/utils/toastApiError";
import { toastSuccess } from "@/utils/toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useAddMember = () => {
  const queryClient = useQueryClient();

  // handle add member success
  const handleAddMemberSuccess = useCallback((chatId: number) => {
    // reset api get detail chat
    queryClient.invalidateQueries({
      queryKey: [CHAT_QUERY_KEYS.CHAT_BY_ID, chatId],
    });

    // toast
    toastSuccess("メンバーを追加しました");
  }, []);

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [CHAT_QUERY_KEYS.ADD_MEMBER],
    mutationFn: ({ chatId, userIds }: { chatId: number; userIds: number[] }) =>
      ChatService.addMember(chatId, userIds),
    onSuccess: (_, variables) => handleAddMemberSuccess(variables.chatId),
    onError: toastApiError,
  });

  return {
    addMember: mutateAsync,
    isAddingMember: isPending,
  };
};
